<!-- Desktop variant -->
<div class="container preview-container" app-drag-drop (fileDropped)="onFileDropped($event)">
  <input type="file" [accept]="allowedMimeTypes" #uploadFile [id]="uploadFileId" (change)="onFileChange($event.target.files)" (cancel)="onCancel($event)" />
  @if (showAddButton && (!fileIsSelected || errorMessage)) {
    <div class="upload-area">
      <h6>{{ 'DOCUMENT.DRAG_DROP_FILE_HERE' | translate }}</h6>
      <img src="../../../../assets/image/upload-file.svg" alt="Upload file icon" />
      <h6 class="or-text">{{ 'COMMON.OR' | translate }}</h6>
      <button type="button" class="btn btn-active" (click)="uploadFile.click()">
        {{ 'DOCUMENT.SELECT_FILE_UPLOAD' | translate }}
      </button>
      @if (errorMessage) {
        <div class="error-message">{{ errorMessage | translate }}</div>
      }
    </div>
  }

  @if (fileIsSelected && !errorMessage) {
    <button type="button" class="delete-file" [attr.aria-label]="'COMMON.CLEAR' | translate" (click)="clearFile()">
      <img src="assets/icons/component_icons/close-white.png" alt="" aria-hidden="true" />
    </button>
    <div class="img-wrap">
      <div class="icon" [ngClass]="getClass(previewMimeType)"></div>
      @if (previewDataUrl) {
        <img class="preview-image" [src]="previewDataUrl" [alt]="previewFileName" />
      }
    </div>
    @if (!previewDataUrl) {
      <div class="preview-fallback">{{ previewFileName }}</div>
    }
  }
</div>

<!-- Mobile variant -->
<!-- I'm commenting this out as it looks redundant to me with the new design. With my update we are going from a full screen upload view in mobile to just keeping the same modal box in mobile. If something turns out to be lacking, we can work with this old mark up again. - Atlan -->
<!-- <div class="mobile d-none d-md-none">
  @if (showAddButton) {
    <input
      type="file"
      [accept]="allowedMimeTypes"
      #uploadFile
      [id]="uploadFileId"
      (change)="onFileChange($event.target.files)"
    />
    <label [for]="uploadFileId" class="btn btn-active">{{ 'DOCUMENT.SELECT_FILE_UPLOAD' | translate }}</label>
  }
  @if (errorMessage) {
    <div class="error-message">{{ errorMessage | translate }}</div>
  }
</div> -->
